import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=0d9831ed&scoped=true"
import script from "./type3.vue?vue&type=script&lang=js"
export * from "./type3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9831ed",
  null
  
)

export default component.exports